// extracted by mini-css-extract-plugin
export var modalFooter = "_ja-0";